import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';

/** Native RouteRef for the score-card entity content tab. */
export const scoreCardRouteRef = createRouteRef();

// Raw component for EntityContentBlueprint loader (not the RoutableExtension wrapper)
export { ScorecardComponent } from './components/ScorecardComponent';

const scoreCardPage = PageBlueprint.make({
  params: {
    path: '/score-card',
    noHeader: true,
    routeRef: scoreCardRouteRef,
    loader: () =>
      import('./components/ScorecardComponent').then(m => <m.ScorecardComponent />),
  },
});

export default createFrontendPlugin({
  pluginId: 'score-card',
  extensions: [scoreCardPage],
});
